const normalizeNumber = (value) => {
    return value.replace('-', '');
}

export default normalizeNumber